function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "checkbox-confirm- copy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "07-desktop-UI",
  transform: "translate(-967.000000, -667.000000)",
  strokeWidth: 2
}, React.createElement("g", {
  id: "checkbox-confirm--copy",
  transform: "translate(968.000000, 668.000000)"
}, React.createElement("polyline", {
  id: "Shape",
  stroke: "#6EC18A",
  points: "7.73245902 14.6885246 14.027541 22.0327869 31.8636066 0"
}), React.createElement("path", {
  d: "M27.511082,15.7377049 C28.3898176,21.3790423 25.6622002,26.9707873 20.6754879,29.7509968 C15.6887757,32.5312063 9.4981722,31.9115794 5.16141613,28.1981698 C0.824660065,24.4847601 -0.740577635,18.4633368 1.23882438,13.1080747 C3.21822639,7.75281261 8.32342053,4.19670965 14.0327869,4.19670965 C15.8334054,4.19436254 17.6165525,4.54974378 19.2786885,5.24222951",
  id: "Shape",
  stroke: "#3F5063"
}))));

var SvgCircleTicked = function SvgCircleTicked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircleTicked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-ticked.aa399743.svg";
export { ForwardRef as ReactComponent };